export default __webpack_public_path__ + "static/N0066-f815cdc9a54cb6149b6b47bf87941d98.png";